import React from 'react';

import { twoCols } from './common';
import FilterOption from './FilterOption';

export interface FilterOption {
    label?: string;
    value: string;
    slug: string;
}
interface SearchFilterProps {
    name: string;
    options: FilterOption[];
    slug: string;
    handleChange: (isChecked: boolean, option: FilterOption) => void;
    selectedOptions: FilterOption[];
}
export default function SearchFilter({ name, options, slug, handleChange, selectedOptions }: SearchFilterProps) {
    return (
        <div>
            <h6 className="pl-6 text-primary mb-2 text-sm font-semibold">{name}</h6>
            <div className={`relative px-6 grid gap-4 leading-tight ${twoCols.includes(slug) ? 'grid-cols-2' : ''}`}>
                {options.map((option, i) => (
                    <FilterOption
                        key={i}
                        label={option.label}
                        filterSlug={slug}
                        onChange={(isChecked) => handleChange(isChecked, option)}
                        checked={!!selectedOptions.find((opt) => opt.value === option.value)}
                    />
                ))}
            </div>
        </div>
    );
}
